import ReduxModal from './ReduxModal';

export default ReduxModal;
